import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { CheckCircleOutlined, MinusCircleOutlined } from '@ant-design/icons';

const Radio = (props) => {
  const radioClasses = {
    radio: true,
    'radio--checked': props.checked,
    'radio--disabled': props.disabled,
    [`${props.className}`]: props.className,
  };
  let radioInput = null;

  return (
    <label
      className={classNames(radioClasses)}
      htmlFor={props.id}
      onKeyDown={(e) => {
        // Trigger change event if label is focused and user presses spacebar
        if (e.keyCode === 32) {
          e.preventDefault();
          radioInput.click();
        }
      }}
      tabIndex={props.tabIndex}
      disabled={props.disabled}>
      <span className="radio-icon">
        {props.checked ? (
          <CheckCircleOutlined style={{ color: '#006B8F' }} />
        ) : (
          <MinusCircleOutlined style={{ color: '#b1c1c5' }} />
        )}
      </span>
      {props.label ? <span className="radio-label">{props.label}</span> : null}
      <input
        ref={(input) => {
          radioInput = input;
        }}
        type="radio"
        name={props.name}
        checked={props.checked}
        id={props.id}
        value={props.value}
        onChange={props.onChange}
        tabIndex={props.tabIndex}
        disabled={props.disabled}
      />
    </label>
  );
};

Radio.propTypes = {
  checked: PropTypes.bool,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  id: PropTypes.string,
  label: PropTypes.string,
  name: PropTypes.string,
  onChange: PropTypes.func,
  tabIndex: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

Radio.defaultProps = {
  checked: false,
  className: null,
  disabled: false,
  id: null,
  label: null,
  name: null,
  onChange: null,
  tabIndex: '0',
  value: null,
};

export default Radio;
